import { Icon, IconButton, Typography } from '@smartgift/frontend-toolkit';
import { forwardRef, useState } from 'react';

import * as S from './style';

const NOTIFICATION_SIZE = {
  toast: '348px'
};

const NOTIFICATION_TYPE = {
  inline: 'inline',
  toast: 'toast'
};

const STATUS = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info'
};

const STATUS_ICON = {
  success: 'f-success',
  warning: 'f-warning',
  error: 'f-error',
  info: 'f-tooltip'
};

const Notification = forwardRef(
  (
    {
      title,
      message,
      type = NOTIFICATION_TYPE.inline,
      status = STATUS.success,
      isClosable = false,
      onClose,
      icon,
      ...rest
    },
    ref
  ) => {
    const [isShown, setIsShown] = useState(true);

    const handleClose = () => {
      onClose && onClose();
      setIsShown(false);
    };

    if (!isShown) return null;

    return (
      <S.Notification ref={ref} $size={NOTIFICATION_SIZE[type]} $status={status} {...rest}>
        {icon || <Icon name={STATUS_ICON[status]} />}
        <S.NotificationBody>
          {title && <Typography variant="body2Bold">{title}</Typography>}
          {message && <Typography variant="body2">{message}</Typography>}
        </S.NotificationBody>
        {isClosable && (
          <IconButton variant="link">
            <Icon name="close" onClick={handleClose} color="var(--color-neutral-500)" />
          </IconButton>
        )}
      </S.Notification>
    );
  }
);

Notification.displayName = 'Notification';

Notification.S = S;

export { Notification };
